import { AltraParte } from "./altraparte";
import { DocumentoAllegato } from "./documento-allegato";
import { Parte } from "./parte";
import { Categoria } from "./tipologiche/categoria";

export class Controparte {
  id: string;
  dataAssociazione: number = +new Date();
  parte: Parte;
  legaleControparte: AltraParte;
  dataTermine: number;
  primario: boolean;
  ritirato: boolean;
  cliente: boolean;
  documenti: DocumentoAllegato[];
  note: string;
  selected?: boolean;
  categoria?: Categoria;
  categoriaAltraParte?: Categoria;
  societa?: InfoSocieta[];
  flagAttore: boolean;
  nominativo: string;
}
export class InfoSocieta {
  societa: string;
  carica: string;
  dataDal: number;
  dataAl: number;
  incaricoRimosso: boolean;
  percPartecipazione: number;
  fiscale: string;
  reaSocieta: string;
  codiceAteco: string;

  visureCamerali: {
    codiceVisura: string;
    descrizioneVisura: string;
  }[];

  anniInteressati: {
    annoComunicazione: number;
    annoAnnullato: number;
    codiceCausale: string;
    descrizioneCausale: string;
  }[];

  certificati: {
    codiceDocumento: string;
    documentiRichiesti: boolean;
    documentiArrivati: boolean;
    documentiIncompleti: boolean;
    descrizioneCertificato: string;
    dataRichiesta: number;
    numSollecitiInviati: number;
    numProtocolloEntrata: number;
    dataProtocolloEntrata: number;
  }[];
}
